import { Cell, Grid, VFlow } from 'bold-ui'
import { SimNaoRadioGroupField } from 'components/form'

import { InspecaoColoRadioField } from './InspecaoColoRadioField'
import { CitopatologicoPerguntaField } from './model-citopatologico'

export function CitopatologicoExameClinicoModalStep() {
  return (
    <VFlow>
      <Grid>
        <Cell data-testid='inspecaoColo'>
          <InspecaoColoRadioField name={CitopatologicoPerguntaField.inspecaoColo} required />
        </Cell>
        <Cell data-testid='sinaisSugestivosDeIst'>
          <SimNaoRadioGroupField
            name={CitopatologicoPerguntaField.sinaisSugestivosDeIst}
            label='Sinais Sugestivos de IST'
            required
          />
        </Cell>
      </Grid>
    </VFlow>
  )
}
